import { useEffect } from 'react'

import { useHistory } from 'react-router-dom'
import { TypesRoutes } from 'routes/mixedRoutes/types'
import { useNavBar } from 'hooks/useNavBar'
import { ActionIconEnum } from 'common/enums/ActionIcon'
import { Icons } from 'utils/icons'
import { FlexRow } from 'components'
import useBoundState from 'store'
import { TabIdEnum } from 'common/enums/TabIdEnum'

import { Text } from '@interco/inter-ui/components/Text'
import { Button } from '@interco/inter-ui/components/Button'
import { formatToBRL, formatToBrazilianDate } from '@interco/lib-util'

import * as S from './RedemptionReceipt.styles'
import {
  analyticsRedemptionReceipt,
  analyticsRedemptionReceiptLoad,
} from './RedemptionReceipt.tags'

export const RedemptionReceipt = () => {
  const history = useHistory()
  const contentTitle = useBoundState((state) => state.contentTitle)
  const contentMyTitle = useBoundState((state) => state.contentMyTitle)

  const SINGLE_TICKET_PRICE_FORMATTED = 'R$ 3,00'
  const getTickets = useBoundState((state) => state.getTickets)
  const {
    minRedemptionValue,
    redemptionQuantity,
    repurchaseQuantity,
    totalRedemptionAmount,
    repurchaseValue,
  } = useBoundState((state) => state.redemptionResponse)

  const hasRepurchase = repurchaseQuantity > 0

  useNavBar({
    actionIcons: {
      rightIcon: ActionIconEnum.HOME,
    },
    backListener: () => getTickets({ onTransmission: () => history.push(TypesRoutes.AFTER_SALES) }),
  })

  const successIcon = <Icons.Check width="32px" height="32px" color="var(--neutral-theme)" />

  const handleMyTickets = () => {
    getTickets({
      onTransmission: () => history.push(TypesRoutes.AFTER_SALES),
      selectedTab: TabIdEnum.MY_TICKETS,
    })
  }

  const handleGoHome = () => {
    getTickets({ history, pathname: TypesRoutes.LANDING_PAGE_HOME })
  }

  useEffect(() => {
    analyticsRedemptionReceipt({
      value: formatToBRL(totalRedemptionAmount),
      payment: hasRepurchase ? 'Débito Inter' : 'Crédito Inter',
    })

    analyticsRedemptionReceiptLoad({
      is_voluntary_redemption: hasRepurchase ? 'false' : 'true',
    })
  }, [])

  const renderRepurchaseReceipt = () => (
    <>
      <Text variant="body-3" colorWeight={400}>
        {`Você receberá em sua conta ${
          redemptionQuantity > 1 ? `${redemptionQuantity} transações` : 'uma transação'
        }  no valor de ${formatToBRL(minRedemptionValue)} e ${
          repurchaseQuantity > 1 ? `${repurchaseQuantity} cobranças` : '1 cobrança'
        } no valor de
        ${SINGLE_TICKET_PRICE_FORMATTED}, ${
          repurchaseQuantity > 1
            ? `referentes aos ${contentTitle.value2Lowercase} comprados.`
            : `referente ao ${contentTitle.value1Lowercase} comprado.`
        }`}
      </Text>
      <FlexRow title="Quantidade" value={repurchaseQuantity} />
      <FlexRow title="Total" value={formatToBRL(repurchaseValue)} />
      <FlexRow title="Forma de pagamento" value="Débito Inter" />
      <FlexRow title="Data da solicitação" value={formatToBrazilianDate(new Date())} />
    </>
  )

  const renderValueReceipt = () => (
    <>
      <FlexRow title="Valor resgatado" value={formatToBRL(totalRedemptionAmount)} />
      <FlexRow title={`${contentTitle.value2} resgatados`} value={redemptionQuantity} />
      <FlexRow title="Data da solicitação" value={formatToBrazilianDate(new Date())} />
    </>
  )

  return (
    <S.Container>
      <S.Header>
        <S.SuccessSign>{successIcon}</S.SuccessSign>
        <Text variant="headline-h2" as="h2" semiBold>
          Resgate solicitado!
        </Text>
      </S.Header>
      <S.Content>{hasRepurchase ? renderRepurchaseReceipt() : renderValueReceipt()}</S.Content>
      <S.Footer>
        <Button
          fullWidth
          variant="primary"
          onClick={handleMyTickets}
          data-testid="my-capitalizations-button"
        >
          Acessar {contentMyTitle.value2Lowercase}
        </Button>
        <Button fullWidth variant="secondary" onClick={handleGoHome} data-testid="home-button">
          Voltar para a home
        </Button>
      </S.Footer>
    </S.Container>
  )
}
